export const HORIZONTAL_BAR_CHART_BASE = {
    chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: { show: false }
    },
    colors: ['#AD509E', '#8C3F7D'],
    plotOptions: { bar: { horizontal: true } },
    stroke: {
        width: 1,
        colors: ['#fff']
    },
    xaxis: { categories: [] },
    tooltip: {
        y: {
            formatter: function (val) {
                return val;
            }
        }
    },
    fill: { opacity: 1 },
    legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
    }
};
  